<template>
  <!-- <div class="main">
      <img v-default-img src="../img/yhtj.jpg" alt="">
  </div>-->
  <div class="content alarmCensus" ref="tableBox" id="tableBox">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 隐患统计
        </span>
        <div class="normalNav zaddBtn">
          <button class="BlueSmBtn" @click="search">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
        </div>
        <div class="searchForm1">
          <el-form ref="formData" :model="formData">
            <el-form-item label="统计方式">
              <el-select v-model="formData.style">
                <el-option
                  v-for="item in staticalStyle"
                  :key="item.id"
                  :value="item.id"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="部门">
              <el-input
                placeholder="请选择部门"
                v-model="formData.curAreaName"
                @focus="$refs.departDialog.look()"
              ></el-input>
            </el-form-item>
            <el-form-item label="开始时间:" v-if="formData.style === 1">
              <el-date-picker
                v-model="formData.startTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间:" v-if="formData.style === 1">
              <el-date-picker
                v-model="formData.endTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-form>
        </div>
        <div class="detailtab nonedetailtab" v-if="!showCont">
          <div>请搜索</div>
        </div>
        <div class="detailtab" v-if="showCont">
          <div class="leftBar" v-if="this.formData.style === 0">
            <leftChart v-if="this.chartData.xData.length>0" :chartData="chartData"></leftChart>
          </div>
          <div class="leftBar" v-if="this.formData.style === 1">
            <leftCharts v-if="this.chartDatas.xData.length>0" :chartDatas="chartDatas"></leftCharts>
          </div>
          <div v-if="this.formData.style === 0" class="rightTable">
            <el-table class="stripeTable" :data="tableData">
              <el-table-column label="部门" prop="deptName"></el-table-column>
              <el-table-column label="待审核" prop="toCheck"></el-table-column>
              <el-table-column label="待处理" prop="toHandle"></el-table-column>
              <el-table-column label="处理中" prop="handling"></el-table-column>
              <el-table-column label="已处理" prop="handled"></el-table-column>
            </el-table>
          </div>
          <div v-if="this.formData.style === 1" class="rightTable">
            <el-table class="stripeTable" :data="tableDatas">
              <el-table-column label="隐患类型" prop="riskTypeDesc"></el-table-column>
              <el-table-column label="数量" prop="num"></el-table-column>
            </el-table>
          </div>
        </div>
        <depart-dialog ref="departDialog"></depart-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  components: {
    normalNav: () => import("public/normalNav"),
    departDialog: () => import("./departDialog"),
    leftChart: () => import("./leftChart"),
    leftCharts: () => import("./leftCharts")
  },
  data() {
    return {
      tabName: "jsgl",
      formData: {
        style: "",
        deptId: "",
        endTime: "",
        startTime: "",
        curAreaName: "",
      },
      staticalStyle: [
        { id: 0, label: "按状态统计" },
        { id: 1, label: "按类型统计" }
      ],
      showCont: false,
      tableData: [],
      tableDatas: [],
      chartData: { xData: [], seriesData: { one: [], two: [], three: [], four: [] } },
      chartDatas: { xData: [], seriesData: []},
    };
  },
  methods: {
    //搜索
    search() {
      this.chartData.xData = [];
      this.chartData.seriesData = { one: [], two: [], three: [], four: [] };
      this.chartDatas.xData = [];
      this.chartDatas.seriesData = [];
      if(this.formData.style === 0) {
        //console.log("状态统计")
        if(!this.formData.deptId) {
          this.$notify({
            message: "请选择部门",
            type: "warning"
          })
        } else {
          this.$axiosget("operation/risk/count_by_dept_status", {
          params: {
            handleDept: this.formData.deptId
          }
        }).then(res => {
          let data = res.data.data;
          this.tableData = res.data.data;
          let toCheck = [], toHandle = [], handling = [], handled = [];
          data.forEach(element => {
            this.chartData.xData.push(element.deptName);
            toCheck.push(element.toCheck);
            toHandle.push(element.toHandle);
            handling.push(element.handling);
            handled.push(element.handled);
          });
          this.chartData.seriesData = { one: toCheck, two: toHandle, three: handling, four: handled };
          this.showCont = true;
          //console.log(this.chartData,"chartData")
        })
        }

      } else if(this.formData.style === 1) {
        //console.log("类型统计")
        this.$axiosget("operation/risk/count_by_type", {
          params: {
            handleDept: this.formData.deptId,
            startTime: this.formData.startTime,
            endTime: this.formData.endTime
          }
        }).then(res => {
          //console.log(res.data)
          let datas = res.data.data;
          this.tableDatas = res.data.data;
          datas.forEach(element => {
            this.chartDatas.xData.push(element.riskTypeDesc);
            this.chartDatas.seriesData.push(element.num)
          });
          this.showCont = true;
          //console.log(this.chartDatas,"chartDatas")
        })
      } else {
        this.$notify({
          message: "请选择统计方式",
          type: "warning"
        })
        return
      }
    },
    //重置
    reset() {
      this.formData = {
        style: "",
        deptId: "",
        endTime: "",
        startTime: "",
        curAreaName: "",
      }
    }
  },
  created() {
    //console.log(this.formData.curAreaName)
  }
};
</script>

<style scoped lang="less">
/* .main{
  width: 100%;
    height: 100%;
    padding-top: 0 !important;
}
.main img{
  width: 100%;
} */
.nonedetailtab {
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(181, 181, 181);
}
.breadcrumb {
  margin-top: 0;
}
.detailtab {
  background-color: #181c2e;
  display: flex;
  width: 100%;
  height: calc(100% - 73px);
  padding-top: 20px;
  .rightTable {
    width: 520px;
    height: 100%;
    background-color: #232944;
    padding: 34px 40px 90px;
  }
  .leftBar {
    flex: 1;
    position: relative;
    margin-right: 20px;
  }
}
</style>
<style lang='less'>
.boxs .alarmCensus {
  height: 100%;
  padding: 0 0 43px 0;
}
.boxs .alarmCensus .el-tabs {
  height: 100%;
}
.boxs .alarmCensus .el-tabs .el-tabs__content {
  height: calc(100% - 52px);
}
.boxs .alarmCensus .el-tabs .el-tabs__content .el-tab-pane {
  height: 100%;
}
.alarmCensus .el-tabs,
.alarmCensus .el-tabs .content,
.alarmCensus .el-tabs .el-tabs__content .el-tab-pane {
  height: 100%;
}
.alarmCensus .el-tabs .el-tabs__content {
  height: calc(100% - 52px);
}
.box .alarmCensus {
  height: 100%;
  padding: 0 0 43px 0;
}
.alarmCensus .el-form .el-form-item .el-form-item__content {
  width: calc(100% - 100px);
  .el-date-editor {
    width: calc(100%);
  }
  .el-range-input {
    background: #2e3657;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute4/dataAnalysis/reportForms/YHstatistics.vue